import { Injectable } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { PopupComponent } from '../popup.component';

import { POPUP } from '../../../../core/properties/application.properties';
@Injectable({
  providedIn: 'root',
})
export class PopupService {
  private defaultModalConfiguration: NgbModalOptions = {
    centered: true,
    size: 'lg',
    backdrop: 'static',
    keyboard: false,
  };

  constructor(private modalService: NgbModal) {}

  /** Modal for infromation popup */
  information(messages: string[], config = this.defaultModalConfiguration) {
    const modalRef = this.modalService.open(PopupComponent, config);
    modalRef.componentInstance.messages = messages;
    modalRef.componentInstance.openModal(POPUP.TYPES.INFORMATION);
  }

  /** Modal for confirmation popup */
  confirmation(messages: string[], config = this.defaultModalConfiguration) {
    const modalRef = this.modalService.open(PopupComponent, config);
    modalRef.componentInstance.messages = messages;
    modalRef.componentInstance.openModal(POPUP.TYPES.CONFIRMATION);

    return modalRef.result;
  }
}
